import React, { useEffect, useState } from 'react'
import { Button, Drawer, Divider } from 'antd'
import { MenuUnfoldOutlined } from '@ant-design/icons'
import './styles.scss'

const items = [
    {
        key: '1',
        label: 'Introduction',
        link: '#introduction',
    },
    {
        key: '2',
        label: 'Licensed & Accredited',
        link: '#licensed',
    },
    {
        key: '3',
        label: 'Safe Transport',
        link: '#safe-transport',
    },
    {
        key: '4',
        label: 'Trusted Accommodations',
        link: '#accommodations',
    },
    {
        key: '5',
        label: 'Licensed Local Guides',
        link: '#guides',
    },
    {
        key: '6',
        label: '24/7 Support',
        link: '#support',
    },
    {
        key: '7',
        label: 'Secure Booking & Payment',
        link: '#payment',
    },
    {
        key: '8',
        label: 'Transparency',
        link: '#transparency',
    }
]

const TrustAndSafety = () => {
    const [isNavDrawerOpen, setIsNavDraweOpen] = useState(false);

    useEffect(() => {
        const url = window.location.href;
        const section = url.split('#')[1];
        if (section) {
            scrollToSection(`#${section}`);
        }
    }, []);

    const scrollToSection = (id) => {
        const section = document.querySelector(id);
        if (section) {
            const offset = window.innerWidth > 768 ? 100 : 60;
            const sectionPosition = section.getBoundingClientRect().top + window.pageYOffset - offset;

            window.scrollTo({
                top: sectionPosition,
                behavior: 'smooth',
            });
        }
    };

    return (
        <div className='trust-safety section_main' style={{ marginBottom: '60px' }}>
            <div className='top_padding_container'>
                <h1 className='header_1'>
                    Safety & Trust
                </h1>
            </div>

            <div className='mobile_nav'>
                <Button onClick={() => setIsNavDraweOpen(true)}><MenuUnfoldOutlined /> Open Menu</Button>
            </div>

            <div className='body'>
                <div className='terms__nav'>
                    {items.map((item) => (
                        <div
                            key={item.key}
                            className='terms__nav__container__items__item'
                            onClick={() => scrollToSection(item.link)}
                        >
                            {item.label}
                        </div>
                    ))}
                </div>

                <div className='terms'>
                    <p className='paragraph' id='introduction'>
                        At Visit Pearl, we understand that travel is not just about destinations—it's about confidence. When you book a journey with us, you're placing your trust in our hands, and we take that responsibility seriously. From industry accreditations to verified partners and secure payment systems, we've built our services on a foundation of safety, professionalism, and transparency.
                    </p>

                    <Divider />

                    <h2 className='heder_2 sec' id='licensed'>
                        Officially Licensed & Accredited
                    </h2>
                    <p className='paragraph'>
                        Visit Pearl is a registered travel business with both the Sri Lanka Tourism Development Authority (SLTDA) and an Australian Business Number (ABN). This dual registration reflects our cross-border commitment to delivering professional and compliant travel experiences.
                    </p>
                    <p className='paragraph'>
                        All of our local partners—including guides, drivers, and accommodation providers—are also registered with the SLTDA, ensuring they meet rigorous national standards for licensing, training, and service delivery.
                    </p>
                    <p className='paragraph'>
                        We're also proud to partner with CoverMore, a leading provider of travel insurance in Australia. While insurance is optional, we strongly recommend travelers purchase coverage, either through us or independently, for added peace of mind.
                    </p>

                    <Divider />

                    <h2 className='heder_2 sec' id='safe-transport'>
                        Safe, Private Transport with Registered Professionals
                    </h2>
                    <p className='paragraph'>
                        We provide private vehicles—cars or vans—based on group size, ensuring comfortable, efficient travel between destinations. Every vehicle is operated by a driver registered with the SLTDA. In many cases, drivers and guides operate as a team, offering coordinated service throughout the journey.
                    </p>
                    <p className='paragraph'>
                        This arrangement ensures that all transport is delivered by professionals trained and recognized by the Sri Lankan government's tourism authority.
                    </p>

                    <Divider />

                    <h2 className='heder_2 sec' id='accommodations'>
                        Trusted Accommodations with Verified Standards
                    </h2>
                    <p className='paragraph'>
                        We exclusively partner with hotels and guesthouses that are SLTDA-registered and hold official star ratings. These properties are subject to regular inspections and re-registration requirements that verify their compliance with cleanliness, safety, and service standards.
                    </p>

                    <Divider />

                    <h2 className='heder_2 sec' id='guides'>
                        Professionally Trained, Licensed Local Guides
                    </h2>
                    <p className='paragraph'>
                        Our local guides are the heart of the Visit Pearl experience. All are certified and registered through the SLTDA, having completed formal training in areas such as first aid, emergency response, cultural interpretation, and traveler support.
                    </p>
                    <p className='paragraph'>
                        Language proficiency is also a core part of their training, with many guides fluent in English and other major languages to better assist international travelers. This ensures clear communication, enriched storytelling, and a more personal experience throughout your journey.
                    </p>
                    <p className='paragraph'>
                        They are not only knowledgeable and personable, but also backed by official qualifications and licensing that guarantee professionalism at every step of your trip.
                    </p>

                    <Divider />

                    <h2 className='heder_2 sec' id='support'>
                        24/7 Local Support & Emergency Assistance
                    </h2>
                    <p className='paragraph'>
                        In addition to your guide, our on-call support team based in Sri Lanka is available around the clock should any issue arise. Whether you encounter a delay, require assistance, or need to make last-minute changes, we're here to respond promptly and provide practical help on the ground.
                    </p>
                    <p className='paragraph'>
                        For matters such as cancellations, illness, or trip disruptions, please refer to our detailed Terms and Conditions outlining policies and procedures.
                    </p>

                    <Divider />

                    <h2 className='heder_2 sec' id='payment'>
                        Secure Booking & Payment Protection
                    </h2>
                    <p className='paragraph'>
                        To safeguard your payments, Visit Pearl has integrated eWAY (eway.com.au)—a secure online payment gateway—for processing all online transactions. When launched, payments will be handled exclusively through eWAY's API, with data processed directly into our business account.
                    </p>
                    <p className='paragraph'>
                        Until this is live, we are using direct bank transfers into our business account registered with Commonwealth Bank Australia (Commbank). Payments are only accepted after travel plans are finalised and agreed upon by both parties, ensuring clarity and mutual understanding before any transaction occurs.
                    </p>
                    <p className='paragraph'>
                        We maintain strict record-keeping practices and do not store or process sensitive payment data outside our secure systems.
                    </p>

                    <Divider />

                    <h2 className='heder_2 sec' id='transparency'>
                        Building Trust Through Transparency
                    </h2>
                    <p className='paragraph'>
                        We actively collect and publish customer testimonials—only after confirmation—to maintain authenticity and integrity in our reviews.
                    </p>
                    <p className='paragraph'>
                        We are partnered with CoverMore (insurance), Aviasales (flight platform), Microsoft Azure (web hosting), eWAY (payment processing), and Commbank (business banking).
                    </p>
                    <p className='paragraph'>
                        Our bookings come with a commitment to satisfaction and service quality, supported by transparent policies and a customer-first approach.
                    </p>

                    <Divider />

                    <h2 className='heder_2 sec'>
                        Travel Confidently with Visit Pearl
                    </h2>
                    <p className='paragraph'>
                        Every detail of your journey is planned with care, not just for convenience, but for your safety and peace of mind. Our professional standards, reliable partners, and secure systems are in place so you can focus on what really matters—enjoying Sri Lanka.
                    </p>
                    <p className='paragraph'>
                        If you have any questions about our safety measures or how we operate, feel free to reach out. We're here to help at every step.
                    </p>
                </div>
            </div>

            <Drawer
                title="Safety & Trust Sections"
                className='home__nav__drawer'
                rootClassName='home__nav__drawer_body'
                placement='bottom'
                closable={false}
                open={isNavDrawerOpen}
                onClose={() => setIsNavDraweOpen(false)}
                height='70vh'
                headerStyle={{ display: 'none' }}
            >
                <div className='terms__nav_drawe'>
                    {items.map((item) => (
                        <div
                            key={item.key}
                            className='terms__nav__container__items__item_drawer'
                            onClick={() => {
                                scrollToSection(item.link)
                                setIsNavDraweOpen(false)
                            }}
                        >
                            {item.label}
                        </div>
                    ))}
                </div>
            </Drawer>
        </div>
    )
}

export default TrustAndSafety